import { BSO_DEVELOP_MODE_ON_FRONT, URL_API_SEND_NOTIFY, urlAPI, urlAPIService, urlAPIv2, urlAUTH, urlSCANING } from "../urls"





type FetchOptions = RequestInit & {
    headers?: HeadersInit
}
const defaultFetch = window.fetch

const API_ORIGINS = new Set([urlAPI,  URL_API_SEND_NOTIFY, urlAUTH, urlAPIService, urlSCANING] // urlAPIv2
        .filter(Boolean)
        .map((u) => {
            try { return new URL(u).origin; } catch { return ""; }
        })
        .filter(Boolean)
);



export function getBsoApiHeaders (): Record<string, string> {
    const headers: Record<string, string> = {}
    const isDevMode = process.env.REACT_APP_IS_DEV === 'true'
    const isDevModeFront = window.localStorage.getItem(BSO_DEVELOP_MODE_ON_FRONT) === 'true';
    headers["BSO-Hash"] = window.bsotoken();

    if (isDevMode || isDevModeFront) {
        headers["BSO-Dev"] = "true";
    }

    return headers
}

export default async function customFetch (url: RequestInfo | URL, options: FetchOptions = {}): Promise<Response> {
    if (isOurApiRequest(url)) {
        const defaultHeaders = getBsoApiHeaders()
        options.headers = {
            ...options.headers,
            ...defaultHeaders
        }

    }
    return await defaultFetch(url, options)
}




function getUrlString(input: RequestInfo | URL): string {
    if (input instanceof Request) return input.url;
    if (input instanceof URL) return input.toString();
    return String(input);
}

function isOurApiRequest(input: RequestInfo | URL): boolean {
    try {
        const u = new URL(getUrlString(input), window.location.origin); 
        return API_ORIGINS.has(u.origin);
    } catch {
        return false;
    }
}
